import React from 'react';
import RatingCircle from '../custom-widgets/RatingCircle';
import ForensicGauge from '../custom-widgets/ForensicGauge';
import styles from './PerformanceIntel.module.css';

const PerformanceIntel = ({ player, positionStats, positionalMetrics, isMember }) => {
    return (
        <section className={styles['desktop-rating-dashboard-v2']} style={{ marginTop: '48px' }}>
            <div className={styles['desktop-gauge-column']}>
                <h2 className={styles['desktop-section-heading']}>Forensic <span>Value Gauge</span></h2>
                <div className={`${styles['desktop-panel']} ${styles['desktop-gauge-panel']}`}>
                    <ForensicGauge
                        value={player?.base_value}
                        forcedValue={player?.forced_sale_value}
                        premiumValue={player?.premium_value}
                        isMember={isMember}
                    />
                </div>
            </div>

            <div className={styles['desktop-rating-column']}>
                <h2 className={styles['desktop-section-heading']}>Performance <span>Rating</span></h2>
                <div className={`${styles['desktop-panel']} ${styles['desktop-rating-panel']}`}>
                    <RatingCircle rating={positionStats?.rating || 0} />
                </div>
            </div>

            <div className={styles['desktop-full-width-stats']}>
                <h2 className={styles['desktop-section-heading']}>Positional <span>Stats</span></h2>
                <div className={styles['desktop-stat-horizontal-row']}>
                    {positionalMetrics.map((item, index) => (
                        <div key={`pos-h-${index}`} className={styles['desktop-stat-tile-horizontal']}>
                            <span className={styles['stat-horizontal-value']}>{item.value}</span>
                            <span className={styles['stat-horizontal-label']}>{item.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PerformanceIntel;
